
export class MortgageTerm {
  mortgageTermId: number | undefined;
  mortgageAppliedFor: string | undefined;
  amount: number | undefined;
  lenderCaseNumber: string | undefined;
  appraisedValue: number | undefined;
}
